{
	"backToManageDeclarations": "Back to Manage declarations"
}
